"use strict";

exports.__esModule = true;
exports.DeviceDetailsDataProvider = void 0;
var _react = _interopRequireWildcard(require("react"));
var _DeviceDetailsURLFilter = require("../DeviceDetailsURLFilter");
var _URLFilter = require("../../Core/URLFilter");
var _ReportingPeriod = require("../../Time/ReportingPeriod");
var _DeviceContext = require("../../Device/DeviceContext");
var _Utils = require("../../../Utils");
var _DeviceListContext = require("../../Device/DeviceListContext");
var _PlantStateActivities = require("../../PlantStateActivities");
var _ClassificationContext = require("../../Operator/ClassificationContext");
var _CalendarContext = require("../../Calendar/CalendarContext");
var _CalendarController = require("../../Calendar/CalendarController");
var _dec, _dec2, _class, _DeviceDetailsDataProvider;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Provides data to deviceDetails via contexts.
 */
var DeviceDetailsDataProvider = exports.DeviceDetailsDataProvider = (_dec = _DeviceListContext.DeviceListContext.withContext, _dec2 = _PlantStateActivities.PlantStateActivitiesContext.withContext, _dec(_class = _dec2(_class = (_DeviceDetailsDataProvider = /*#__PURE__*/function (_Component) {
  function DeviceDetailsDataProvider() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(DeviceDetailsDataProvider, _Component);
  var _proto = DeviceDetailsDataProvider.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      devices = _this$props.devices,
      defaultToFirstDevice = _this$props.defaultToFirstDevice,
      allPlantStateActivities = _this$props.allPlantStateActivities,
      children = _this$props.children;
    var plantStateActivities = (0, _PlantStateActivities.getEnabledPlantStateActivities)(allPlantStateActivities);
    return /*#__PURE__*/_react["default"].createElement(_CalendarController.CalendarController, null, function (calendarProps) {
      return /*#__PURE__*/_react["default"].createElement(_CalendarContext.CalendarContext.Provider, {
        value: calendarProps
      }, /*#__PURE__*/_react["default"].createElement(_DeviceDetailsURLFilter.DeviceDetailsURLFilter, null, function (urlFilter) {
        var deviceUuid = urlFilter.filters.device;
        var device = deviceUuid ? (Array.isArray(devices) ? devices : []).find(function (item) {
          return item.uuid === deviceUuid;
        }) : undefined;
        if (device === undefined && defaultToFirstDevice) {
          device = Array.isArray(devices) ? devices[0] : undefined;
        }
        return /*#__PURE__*/_react["default"].createElement(_URLFilter.URLFilterContext.Provider, {
          value: urlFilter
        }, /*#__PURE__*/_react["default"].createElement(_DeviceContext.DeviceContext.Provider, {
          value: device
        }, /*#__PURE__*/_react["default"].createElement(_ReportingPeriod.ReportingPeriodController, null, function (reportingPeriod) {
          return /*#__PURE__*/_react["default"].createElement(_ReportingPeriod.ReportingPeriodContext.Provider, {
            value: reportingPeriod
          }, device ? /*#__PURE__*/_react["default"].createElement(_ClassificationContext.ClassificationContext.Provider, {
            plantStateActivities: plantStateActivities,
            device: device,
            interval: reportingPeriod.interval
          }, children) : children);
        })));
      }));
    });
  };
  return DeviceDetailsDataProvider;
}(_react.Component), _DeviceDetailsDataProvider.defaultProps = {
  devices: undefined,
  allPlantStateActivities: undefined
}, _DeviceDetailsDataProvider)) || _class) || _class);